import apiService from './apiService.js';

const resource = '/role';

export default {
    getRole() {
        return apiService.get(`${resource}`);
    },
};
